import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { IAppState } from '../../state/app.state';
import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import * as FeatureFlagsActions from '../actions/feature-flags.actions';
import { getFeatureFlags } from '../selectors/feature-flags.selectors';
import { FeatureFlags } from 'src/app/models/feature-flags';

@Injectable()
export class FeatureFlagsFacade {
  private getFeatureFlags$: Observable<any> = this.store.pipe(
    select(getFeatureFlags)
  );

  private isUserLoggedIn$: Observable<boolean> =
    this.authFacade.userLoggedIn$();

  private featureFlags$ = combineLatest([
    this.getFeatureFlags$,
    this.isUserLoggedIn$,
  ]).pipe(
    filter((values: [any, boolean]) => {
      const isLoggedIn = values[1];
      return !!isLoggedIn;
    }),
    map((values: [any, boolean]) => {
      const [featureFlags] = values;
      return featureFlags;
    }),
    tap((featureFlags: any) => {
      if (!featureFlags) {
        this.store.dispatch(new FeatureFlagsActions.LoadFeatureFlags());
      }
    })
  );

  public featureFlagsWhenNotNull$: Observable<any> = this.featureFlags$.pipe(
    filter(featureFlags => !!featureFlags)
  );

  public isFeatureFlagEnabled$(flagName: FeatureFlags): Observable<any> {
    return this.featureFlagsWhenNotNull$.pipe(
      switchMap(featureFlags => {
        // Get the string value of the flag.
        const rawFlagValue = featureFlags[flagName];

        // If the flag is not defined, return false.
        if (!rawFlagValue) {
          return of(false);
        }

        let flagValue: boolean = JSON.parse(rawFlagValue);

        // Return an observable of the flag value.
        return of(flagValue);
      })
    );
  }

  constructor(
    private store: Store<IAppState>,
    private authFacade: AuthFacade
  ) {}

  loadFeatureFlags() {
    this.store.dispatch(new FeatureFlagsActions.LoadFeatureFlags());
  }
}
